module.exports = __webpack_public_path__ + "static/media/freshworks.4069429b.png";